
<template>
<div class="container pagebreak default_font">

    <br />
    <br />

    <div>
        <div class="row">
            <div class="col-xs-12 text-left" style="margin-top:30px;">
                <div style="float: left; font-size: 12px; font-family: Times New Roman, Times, serif; margin-left: 10%">
                        <b>Địa chỉ</b> / <i>Add</i>: 18E Cong Hoa, Ward. 4, Tan Binh Dist., HCM <br />
                        <b>SĐT</b> / <i>Tel</i>: (84.28) 71077388. Website: www. republicplaza.vn
                </div>
                <div v-if="projectLogo" class="text-right" style="float: right !important; margin-right: 10%">
                    <img :src="projectLogo" class="resize-project-logo-lg"> </div>
                </div>
            </div>
        </div>

            <div class="text-center" style="font-size: 20px; font-family: Times New Roman, Times, serif; font-weight: bold; text-transform: uppercase;">PHIẾU THU</div>
            <div class="text-center" style="font-size: 16px; font-family: Times New Roman, Times, serif; text-transform: uppercase;"><i>Receipt</i></div>
            <div class="text-center" style="font-size: 12px; font-family: Times New Roman, Times, serif; ">Số / <i>No</i>: <b>{{invoice_general_invoice_data.invoice_general_invoice_code}}</b></div>

        <div class="container" style="margin-top:30px;">
            <div class="row">
                <table class="table table-condensed" style="width:80%; border:0px solid red; margin-left : 10%">
                    <tbody>
                        <tr>
                            <td style="width:30%"><b>Ngày Lập Phiếu</b> / <i>Date</i>: </td>
                            <td style="width:60%"><b class="text-uppercase" style="text-align:left;">{{invoice_general_invoice_data.current_date}}</b></td>
                        </tr>
                        <tr>
                            <td style="width:30%"><b>Ngày Chứng Từ</b> / <i>Date Invoice</i>: </td>
                            <td style="width:40%"><b class="text-uppercase" style="text-align:left;">{{invoice_general_invoice_data.current_date}}</b></td>
                        </tr>
                        <tr>
                            <td style="width:30%"><b>Họ và tên</b> / <i>Full name</i>: </td>
                            <td style="width:60%; text-transform: uppercase;">{{invoice_general_invoice_data.customer_fullname}}</td>
                        </tr>
                        <tr>
                            <td style="width:30%"><b>Địa chỉ</b> / <i>Address</i>: </td>
                            <td style="width:60%">{{invoice_general_invoice_data.address}}</td>
                        </tr>
                        <tr>
                            <td style="width:30%"><b>Nội dung</b> / <i>Description</i>: </td>
                            <td style="width:60%">{{invoice_general_invoice_data.description}}</td>
                        </tr>
                        <tr>
                            <td style="width:30%"><b>Số tiền</b> / <i>Amount</i>: </td>
                            <td style="width:60%">{{invoice_general_invoice_data.expected_amount_show}} (VNĐ)</td>
                        </tr>
                        <tr>
                            <td style="width:30%"><b>Bằng chữ</b> / <i>Total in Words</i>: </td>
                            <td style="width:60%">
                                <b>{{readMoney(invoice_general_invoice_data.expected_amount, "vi")}} ./.</b>
                                <br/>
                                <i>({{readMoney(invoice_general_invoice_data.expected_amount, "en")}} ./.)</i></td>
                        </tr>
                        <!-- <tr>
                            <td style="width:20%">Người Tạo (User created): </td>
                            <td style="width:40%"><b class="text-uppercase" style="text-align:left;">{{invoice_general_invoice_data.user_created_full_name}}</b></td>
                        </tr> -->
                    </tbody>
                </table>

            </div>

            <div class="row">
                <table class="table table-condensed" style="border:0px; margin-left:3% ">
                       
                    <tr>
                        <th class="text-center"><b> Lập bởi</b> <br/><i class='table_column_en'>(Drafted by)</i></th>
                        <th class="text-center">Người nộp tiền<br/><i class='table_column_en'>(Payer by) </i></th>
                        <th class="text-center">Thủ quỹ<br/><i class='table_column_en'>(Cashier)</i></th>
                        <th class="text-center">Giám đốc Điều hành/ BQL Tòa nhà	<br/><i class='table_column_en'>( Managing Director)</i></th>
                    </tr>

                    <br/>
                    <br/>
                    <br/>

                    <tr>
                        <th class="text-center">{{invoice_general_invoice_data.user_created_full_name}}</th>
                        <th class="text-center"></th>
                        <th class="text-center"></th>
                        <th class="text-center"></th>
                    </tr>
                </table>
            </div>
        </div>

        <div class="row ">
            <form class="form-horizontal">

                <div class="">
                    <button
                    id="cmdCancel"
                    type="button"
                    class="btn btn-labeled btn-danger"
                    @click="cancel"
                    style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
                >
            <span class="btn-label">
              <i class="fa fa-mail-reply"></i>
            </span>
            {{$t('common.back')}}
          </button>
                    <button
            id="cmdPrintPdf"
            type="button"
            class="btn btn-labeled btn-warning pull-right"
            @click="print"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{$t('common.printPdf')}}
          </button>
                </div>
            </form>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
// import LTECoreAlert from "@/components/LTESnackBar.vue";
import {
    mapGetters,
    mapActions
} from "vuex";

import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

// https://vue-multiselect.js.org/
import "vue-multiselect/dist/vue-multiselect.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// import Multiselect from "vue-multiselect";
import moment from "moment";
// import LTEModal from "@/components/LTEModal.vue";
import utils from '@/lib/utils';
import i18n from '../../lang'

export default {
    props: ["item"],
    name: "ComponentReceiptPdf_TM",
    data() {
        return {
            projectLogo: null,
            invoice_general_invoice_data: {
                id : 0,
                invoice_general_invoice_code: "",
                expected_amount: 0,
                expected_amount_show: 0,
                user_created: "",
                user_created_full_name: "",
                current_date : moment(new Date(), 'DD/MM/YYYY').format('DD/MM/YYYY'),
                date_created: new Date(),
                payments_type: 1,
                customer_fullname: "",
                address: "",
                description: "",
                month: ""
            },

        };
    },
    watch: {
    },
    computed: {
        ...mapGetters([])
    },
    methods: {
        ...mapActions([
            "ERROR_TOAST",
            "SUCCESS_TOAST",
            "GET_INVOICE_GENERAL_INVOICE_DETAIL"
        ]),

        readMoney: function(number, locale){
            return utils.readMoney(number, locale)
        },
        cancel: function () {
            this.$router.push({
                name: "InvoiceGeneralInvoiceList"
            });
        },
        print: function () {
            document.getElementById("cmdCancel").style.display = "none";
            document.getElementById("cmdPrintPdf").style.display = "none";
            window.print();
            document.getElementById("cmdCancel").style.display = "";
            document.getElementById("cmdPrintPdf").style.display = "";
        },

        convertDateVN(date){
            // Day
            let day = utils.formatSqlDate(date, null, "DD")
            // Month
            let month = utils.formatSqlDate(date, null, "MM")
            // Year
            let year = utils.formatSqlDate(date, null, "YYYY")
            return "Ngày " + day + " tháng " + month +  " năm " + year
        },
        convertDateMonth(date){
            // Month
            let month = utils.formatSqlDate(date, null, "MM")
            // Year
            let year = utils.formatSqlDate(date, null, "YYYY")
            return " tháng " + month +  " năm " + year
        },
        convertDateEN(date){
            return utils.formatSqlDate(date, null, "DD MMM YYYY")
        },

        formatTotalFee(total_fee, isFormat = false){
            if(total_fee != undefined){
                total_fee = utils.makeRoundNumber(total_fee)
                let rs = total_fee.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                return  (rs == 0 && isFormat) ? "-" : rs;
            }
        }
    },
    async mounted() {
        this.projectLogo = sessionStorage.getItem('projectLogo')

        // Add or Update data
        let id = this.$route.params.id;
        if (parseInt(id) !== 0) {
            await this.GET_INVOICE_GENERAL_INVOICE_DETAIL({
                id: id
            }).then(
                function(res) {
                    // monthy_services
                    this.invoice_general_invoice_data.id = res.data.id;
                    this.invoice_general_invoice_data.invoice_general_invoice_code = res.data.code;
                    if(res.data.record_date == null)
                        this.invoice_general_invoice_data.date_created = ""
                    else
                        this.invoice_general_invoice_data.date_created = utils.addTimeZoneForTimestamp(res.data.record_date, "DD/MM/YYYY")
                    this.invoice_general_invoice_data.customer_fullname =  res.data.customer
                    this.invoice_general_invoice_data.address = res.data.address;
                    this.invoice_general_invoice_data.description = res.data.description

                    this.invoice_general_invoice_data.expected_amount = res.data.amount;
                    this.invoice_general_invoice_data.expected_amount_show = this.formatTotalFee(res.data.amount);

                    this.invoice_general_invoice_data.user_created = res.data.user_created;
                    this.invoice_general_invoice_data.user_created_full_name = utils.getFullName(
                        res.data.user_created_first_name,
                        res.data.user_created_last_name,
                        i18n.locale
                    );

                    this.invoice_general_invoice_data.month = utils.formatSqlDate(res.data.date_created, null, "MM");
                }.bind(this)
            ).then();

            await utils.sleep(1000)

             this.print()
        } else {
            // ERROR
        } 
    },
    components: {
        // Multiselect,
        // "lte-modal": LTEModal
    }
};
</script>

<style scoped>
.btn-label {
  position: relative;
  left: -12px;
  display: inline-block;
  padding: 6px 12px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px 0 0 3px;
}

.btn-labeled {
  padding-top: 0;
  padding-bottom: 0;
}

.btn {
  margin-bottom: 10px;
}

.table_total_fee {
  border: 1px solid #000000 !important;
}

.table_total_fee thead tr,
.table_total_fee thead tr th,
.table_total_fee td,
.table_total_fee th {
  border: 1px solid #000000 !important;
}

.container {
  font-family: Times New Roman, Times, serif !important;
}

body {
  font-size: 12px !important;
}
.resize-project-logo-lg {
  height: auto;
  width: auto;
  max-width: 80px;
  max-height: 60px;
}
@media print {
  .pagebreak {
    clear: both;
    page-break-after: always;
  }
}
/* remove title when print */
@page {
  size: auto;
  margin: 0mm;
}

.table_column_en {
    font-style:italic;
    font-weight: 100;
}

table {
    border: 1px solid #CCC;
    border-collapse: collapse;
}

td {
    border-top: 0px solid !important;
}

</style>




// WEBPACK FOOTER //
// src/views/Apartment/InvoiceGeneralInvoicePdf_TM.vue